const PORTAL_LOGIN_CONTINUATION_KEY = 'portalLoginContinuation';

export const getPortalLoginContinuation = () => {
  try {
    const value = sessionStorage.getItem(PORTAL_LOGIN_CONTINUATION_KEY)
    if (!value) return null
    const continuation = JSON.parse(value)
    if (!continuation?.expiresAt || new Date(continuation.expiresAt).getTime() <= Date.now()) {
      sessionStorage.removeItem(PORTAL_LOGIN_CONTINUATION_KEY)
      return null
    }
    return continuation
  } catch {
    return null
  }
}

export const setPortalLoginContinuation = (continuation) => {
  sessionStorage.setItem(PORTAL_LOGIN_CONTINUATION_KEY, JSON.stringify(continuation))
}

export const clearPortalLoginContinuation = () => {
  sessionStorage.removeItem(PORTAL_LOGIN_CONTINUATION_KEY)
}

export const buildPortalDeepLink = (refreshToken) => (
  `productioncrate-portal://google-auth?refresh_token=${encodeURIComponent(refreshToken)}`
)

export const openPortalWithRefreshToken = (refreshToken, onFallback) => {
  const portalUrl = buildPortalDeepLink(refreshToken)
  try {
    window.location.href = portalUrl
  } catch {
    // The fallback makes the deep link available when the browser blocks it.
  }
  window.setTimeout(() => onFallback?.(portalUrl), 2000)
  return portalUrl
}
